import './utils/suppressResizeObserverLoopError';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './sentry/index'
import './styles/index.css';
import Root from './Root';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <Root />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
